import React, { useState } from "react";
import { Box, Paper, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import SidebarMenu from "./AdminPanel/SidebarMenu";
import TopBar from "./AdminPanel/TopBar";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SectionDetails from "./SectionForm/SectionDetails";
import BrandManager from "./SectionForm/BrandManager";
import CategoryManager from "./SectionForm/CategoryManager";
import "bootstrap/dist/css/bootstrap.min.css";

const Section = ({ setSelectedComponent }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [submenuOpen, setSubmenuOpen] = useState(false);

  const handleLogout = async () => {
    try {
      await fetch("/sistema/logout/", { method: "POST", credentials: "include" });
    } catch {}
    localStorage.clear();
    navigate("/login");
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f6fa", mb: 4 }}>
      <SidebarMenu
        open={open}
        setOpen={setOpen}
        submenuOpen={submenuOpen}
        setSubmenuOpen={setSubmenuOpen}
        navigate={navigate}
        handleLogout={handleLogout}
      />
      <Box sx={{ flexGrow: 1 }}>
        <TopBar open={open} setOpen={setOpen} />
        <Box sx={{ width: "95%", mx: "auto", mt: 3 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-start", mb: 3 }}>
            <Button
              variant="contained"
              startIcon={<ArrowBackIcon />}
              sx={{
                textTransform: "none",
                bgcolor: "#1565C0",
                "&:hover": { bgcolor: "#0D47A1" },
                borderRadius: 2,
                px: 2.2,
                fontWeight: 700,
                boxShadow: "0 8px 20px rgba(21,101,192,0.22)",
              }}
              onClick={() => navigate(-1)}
            >
              Regresar
            </Button>
          </Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "2fr 1fr" },
              gridTemplateRows: { xs: "auto auto auto", md: "auto auto" },
              gridTemplateAreas: {
                xs: `"seccion" "brand" "category"`,
                md: `"seccion brand" "category brand"`,
              },
              gap: 3,
            }}
          >
            <Paper
              elevation={4}
              sx={{
                p: { xs: 2, sm: 4 },
                borderRadius: 3,
                gridArea: "seccion",
                backgroundColor: "#fff",
              }}
            >
              <SectionDetails setSelectedComponent={setSelectedComponent} />
            </Paper>
            <Paper
              elevation={4}
              sx={{
                p: { xs: 2, sm: 4 },
                borderRadius: 3,
                gridArea: "brand",
                gridRow: { md: "span 2" },
                backgroundColor: "#fff",
              }}
            >
              <BrandManager />
            </Paper>
            <Paper
              elevation={4}
              sx={{
                p: { xs: 2, sm: 4 },
                borderRadius: 3,
                gridArea: "category",
                backgroundColor: "#fff",
              }}
            >
              <CategoryManager />
            </Paper>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Section;
